import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingBag, ArrowRight } from 'lucide-react';

interface CartConfirmationModalProps {
  onClose: () => void;
  onContinueShopping: () => void;
}

export default function CartConfirmationModal({ onClose, onContinueShopping }: CartConfirmationModalProps) {
  const navigate = useNavigate();

  const handleCheckout = () => {
    onClose();
    navigate('/cart');
  };

  const handleContinueShopping = () => {
    onClose();
    onContinueShopping();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-md w-full p-6 text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <ShoppingBag className="h-8 w-8 text-green-600" />
          </div>
          <h3 className="text-xl font-semibold mb-2">Item Added to Cart!</h3>
          <p className="text-gray-600">Your item has been added to the cart successfully.</p>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={handleCheckout}
            className="w-full bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition-colors flex items-center justify-center gap-2"
          >
            Go to Cart
            <ArrowRight className="h-4 w-4" />
          </button>
          <button
            onClick={handleContinueShopping}
            className="w-full border-2 border-gray-200 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Continue Shopping
          </button>
        </div>
      </div>
    </div>
  );
}